import { ProductsSelectorPartialStoreState, PRODUCTS_SELECTOR_STATE_KEY } from "./products-selector.reducer";

export const getSelected = (state: ProductsSelectorPartialStoreState) => state[PRODUCTS_SELECTOR_STATE_KEY].selected;
